import { defineAsyncComponent } from 'vue';

const openingSupplyEntryDetail = defineAsyncComponent(() =>
  import('@/views/openingSupplyEntry/OpeningSupplyEntryDetail.vue')
);

export function registerOpening(app) {
  app.component('OpeningSupplyEntryDetail', openingSupplyEntryDetail);
}
